import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { customerStation, StationTypesEnum } from '../../../constants/stations'
import { IStation } from '../../../types/station'
import { RootState } from '../../store'
import { setStations } from './action-creators'

interface StationState {
    stations: IStation[] | null
    currentStation: IStation | null
}

const initialState: StationState = {
    stations: null,
    currentStation: null,
}

const stationSlice = createSlice({
    name: 'station',
    initialState,
    reducers: {
        clearStations: (state) => {
            state.stations = initialState.stations
        },
        setCurrentStation: (state, { payload: station }: PayloadAction<IStation>) => {
            state.currentStation = station
        },
    },
    extraReducers: (builder) => {
        builder.addCase(setStations.fulfilled, (state, { payload: stations }) => {
            state.stations = [
                ...stations.filter(({ code }) => code !== StationTypesEnum.MANAGER_STATION),
                customerStation,
            ]
            state.currentStation = stations.find(
                ({ code }) => code === StationTypesEnum.KITCHEN_STATION
            )!
        })
    },
})

export const { clearStations, setCurrentStation } = stationSlice.actions

export const stationSelectors = {
    all: ({ station }: RootState) => station,
    stations: ({ station }: RootState) => station.stations,
    currentStation: ({ station }: RootState) => station.currentStation,
}

export default stationSlice.reducer
